module.exports = __webpack_public_path__ + "assets/img/logistics.b67fc3fd.png";